import { projectStore } from './ProjectStore';
import { uiStore } from './UIStore';

export const rootStore = {
    projectStore,
    uiStore
};

export type RootStore = typeof rootStore; 